export default __webpack_public_path__ + "images/2M.01054b9.png";